import { type FC, type ReactNode, type JSX } from 'react';
import { colors, type SassyColorNames } from 'dibs-sassy/exports/colors';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import styles from './main.scss';

const defaultViewportColor: SassyColorNames = 'sassyColorMoonstone';

type PageLayoutProps = {
    dataTn?: string;
    setOffset?: boolean;
    setViewportBackground?: boolean | SassyColorNames;
    backgroundUrl?: string;
    backgroundRepeat?: string;
    backgroundSize?: string;
    children: ReactNode;
};

export const PageLayout: FC<PageLayoutProps> = props => {
    const {
        children,
        dataTn,
        setOffset = true,
        setViewportBackground,
        backgroundUrl,
        backgroundRepeat,
        backgroundSize,
    } = props;

    let backgroundColor;
    let backgroundImage;
    let backgroundImgStyle;
    let style;

    if (backgroundUrl) {
        backgroundImage = `url('${backgroundUrl}')`;
        backgroundImgStyle = {
            backgroundImage,
            backgroundRepeat: 'inherit',
            backgroundSize: 'auto',
        };
        if (backgroundRepeat) {
            backgroundImgStyle.backgroundRepeat = backgroundRepeat;
        }
        if (backgroundSize) {
            backgroundImgStyle.backgroundSize = backgroundSize;
        }
    }

    let page = (
        <div
            className={classnames(dibsCss.maxW1440px, dibsCss.my0, dibsCss.mxAuto, {
                [styles.setOffset]: setOffset,
            })}
            style={backgroundUrl && !setViewportBackground ? backgroundImgStyle : style}
            data-tn={dataTn}
        >
            {children}
        </div>
    );
    let content = page;

    if (!setOffset && !dataTn && children) {
        page = children as JSX.Element;
    }

    if (setViewportBackground) {
        if (backgroundUrl) {
            style = backgroundImgStyle;
        } else {
            backgroundColor =
                colors[
                    typeof setViewportBackground === 'boolean'
                        ? defaultViewportColor
                        : setViewportBackground
                ];
            if (backgroundColor) {
                style = { backgroundColor };
            }
        }
        content = (
            <div className={styles.viewportContainer} style={style}>
                {page}
            </div>
        );
    }

    return content;
};
